import type { FC } from 'react'

import { sanitizeAndInsertTargetBlank } from '@skytech/utils/html-sanitization'
import CloseIcon from 'mdi-react/CloseIcon'
import { useDispatch, useSelector } from 'react-redux'

import { Translation } from '@/components/i18n/Translation'

import { removeMessage } from './messagesActions'

import './style/messages.scss'

const Messages: FC = () => {
  const dispatch = useDispatch()

  // @ts-ignore
  const messages = useSelector(state => state?.messages?.messages)

  const displayThis = () => {
    if (/localho4st/.test(window.location.hostname)) return false

    return messages.length
  }

  let idx = -1

  return (
    <div id="messages" className={!displayThis() ? 'is-hidden' : ''}>
      {messages.map((message: any) => {
        idx++
        return (
          <div
            key={idx}
            role="button"
            tabIndex={0}
            className="section"
            // @ts-ignore
            onClick={() => dispatch(removeMessage(idx))}
            // @ts-ignore
            onKeyDown={() => dispatch(removeMessage(idx))}
          >
            <h2 className="no-select">
              <Translation id={message.headline} />
            </h2>
            <p
              className="no-select"
              dangerouslySetInnerHTML={{ __html: sanitizeAndInsertTargetBlank(message.text) }}
            />
            <button>
              <CloseIcon />
            </button>
          </div>
        )
      })}

      <div className="help">
        <Translation
          id="Trykk på meldingene over for å merke som lest og komme til appen."
          values={{ messages: messages.length }}
        />
      </div>
    </div>
  )
}

export default Messages
